import { ControlledInput } from 'modules/common/components';
import LocationTypeSelect from 'modules/locations/components/LocationTypeSelect';
import { Control, FormState } from 'react-hook-form';
import { getTranslation } from 'utils/getTranslation';

import { IAddLocationsFormSchema } from './schema';

import RegionSelect from '../RegionSelect';

export enum AddLocationsFormField {
  Name = 'name',
  Type = 'type',
  Region = 'regionId',
}

type ParamType = {
  control: Control<IAddLocationsFormSchema, any>;
};
type FormErrorsType = FormState<IAddLocationsFormSchema>['errors'];

const t = getTranslation('user.CreateLocationsForm');

export const getFormFields = (params: ParamType) => {
  const { control } = params;
  const editLocationsFormFields = [
    {
      name: AddLocationsFormField.Name,
      getErrorMessage: (errors: FormErrorsType) => errors.name?.message,
      Component: () => (
        <ControlledInput
          placeholder={t('enterLocationName')}
          controlled={{
            control,
            name: AddLocationsFormField.Name,
          }}
        />
      ),
    },
    {
      name: AddLocationsFormField.Type,
      getErrorMessage: (errors: FormErrorsType) => errors.type?.message,
      Component: () => (
        <LocationTypeSelect
          adjustDropdownPosition
          controlled={{
            control,
            name: AddLocationsFormField.Type,
          }}
        />
      ),
    },
    {
      name: AddLocationsFormField.Region,
      getErrorMessage: (errors: FormErrorsType) => errors.regionId?.message,
      Component: () => (
        <RegionSelect
          controlled={{ control, name: AddLocationsFormField.Region }}
        />
      ),
    },
  ];
  return editLocationsFormFields;
};
